import React, {useState, useEffect} from 'react';
import {Typography} from '@material-ui/core';

import Service from "../services/Service";
import {Container} from "@material-ui/core";
import {useSelector} from "react-redux";
import ChartPortfolio from "./ChartPortfolio";
import _ from "lodash";
import {getCurrencySymbol} from "./utils/currency";
import {map_sec_history,price_for_chart} from "./utils/mapping";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {formattingMoney} from "./utils/formatting";
import {makeStyles} from "@material-ui/core/styles";
import {getTransactionsLabel} from "./utils/transactions";
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
    table: {
        minWidth: 10
    },
    box: {
        width: '100%',
        overflowX: 'auto',
        marginBottom: 64
    },
    tr: {
        "&:hover": {
            backgroundColor: "#F4F6FA",
        }
    },
});
const service = new Service();
export default function Security(props) {
    window.scrollTo(0, 0);
    const portfolioList = useSelector(store => store.portfolios?.list);
    const selectedIndex = useSelector(store => store.user.portfolio);
    const data = useSelector(store => store.portfolio?.data)
    // const isLoadind = useSelector(store => store.portfolio?.isLoad)
    // const portfolio = portfolioList[selectedIndex] || undefined
    const [prices, setPrices] = useState([]);
    const sec = data?.s.securities[props.match.params.id];
    const classes = useStyles();
    useEffect(() => {
            service.getSecurity(props.match.params.id).then(function (response) {
                    console.log(response)
                   setPrices(response?.data)
                }
            )
    }, []);

    const points = _.map(map_sec_history(props.match.params.id ,data?.transactions), (val)=>{
        let borderColor
        if (val.type == 'SELL'){
            borderColor = '#EF4444'
        } else  {
            borderColor = '#10B981'
        }
        let test  = price_for_chart(val.dateTime,prices)
        //console.log(_.find(prices,{'date':"2011-03-17"}))
        val = {
            x: new Date(val.dateTime).getTime(),
            y: price_for_chart(val.dateTime,prices),
            //y: _.find(prices,{'date':new Date(val.dateTime).getTime()}).close,
            marker: {
                size: 4,
                strokeColor: borderColor,
            },
            label: {
                borderColor: borderColor,
                text: getTransactionsLabel(val.type)+ ': '+ Math.abs(Number(val.quantity)).toLocaleString() +  ' шт.',
            }
        }
        return val
    })
    //_.filter(sec?.events, { 't': 'split'})
    const xaxis = _.map(_.filter(sec?.events, { 't': 'split'}), (val)=>{
        val = {
            x: new Date(val.d).getTime(),
            borderColor: '#8892A7',
            label: {
                borderColor: '#8892A7',
                orientation: 'horizontal',
                text: 'Сплит 1:'+Number(val.v),
            }
        }
        return val
    })

    return (
        <Container style={{marginTop: '30px'}}>
            {!sec &&
            <Typography >В выбранном портфеле нет такого актива</Typography>
            }
            {sec &&
                <>
                    <Typography >{sec.ticker}</Typography>
                    <Typography  color='textSecondary'>{sec.name}</Typography>
                    <ChartPortfolio
                        data ={_.map(prices, 'close')}
                        category ={_.map(prices, 'date')}
                        series_title ={''}
                        currency = {getCurrencySymbol(sec.currency) || ''}
                        points = {points}
                        xaxis = {xaxis}
                    />

                    <Typography >Сделки</Typography>
                    <Box className={classes.box}>
                    <Table aria-label="Сделки" size={'small'} className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Операция</TableCell>
                                <TableCell align="right">Дата</TableCell>
                                <TableCell align="right">Количество</TableCell>
                                <TableCell align="right">Цена</TableCell>
                                <TableCell align="right">Комиссия</TableCell>
                                <TableCell align="right">Сумма</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody hover>
                            {map_sec_history(props.match.params.id ,data?.transactions).map((row) => (
                                <TableRow key={row.id} className={classes.tr}>
                                    <TableCell component="th" scope="row">
                                        {getTransactionsLabel(row.type)}
                                        {/*<Typography variant="body1">{getCurrencyName(row.currency)}</Typography>*/}
                                        {/*<Typography variant="overline">{row.currency}</Typography>*/}
                                    </TableCell>
                                    <TableCell align="right">
                                        {(new Date(row.dateTime)).toLocaleDateString()}
                                        {/*{formattingMoney(row.summa)} {getCurrencySymbol(row.currency)}*/}
                                    </TableCell>
                                    <TableCell align="right">
                                        {Math.abs(Number(row.quantity)).toLocaleString()}
                                        {/*{formattingMoney(row.summa_pc)}*/}
                                    </TableCell>
                                    <TableCell align="right">
                                        {formattingMoney(row.price)} {getCurrencySymbol(row.currency)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {formattingMoney(row.commission)} {getCurrencySymbol(row.commission_currency)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {formattingMoney(Math.abs(Number(row.summa_full)))} {getCurrencySymbol(row.currency)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    </Box>
                    {!_.isEmpty(_.filter(sec?.events, { 't': 'div'})) &&
                        <>
                            <Typography>Дивиденды</Typography>
                            <Box className={classes.box}>
                            <Table aria-label="Дивиденды" size={'small'} className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Дата</TableCell>
                                        <TableCell align="right">Сумма</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody hover>
                                    {_.orderBy(_.filter(sec?.events, { 't': 'div'}),'d','desc').map((row) => (
                                        <TableRow key={row.d} className={classes.tr}>
                                            <TableCell component="th" scope="row">
                                                {(new Date(row.d)).toLocaleDateString()}
                                                {/*<Typography variant="body1">{getCurrencyName(row.currency)}</Typography>*/}
                                                {/*<Typography variant="overline">{row.currency}</Typography>*/}
                                            </TableCell>
                                            <TableCell align="right">
                                                {formattingMoney(Number(row.v))} {getCurrencySymbol(row.cur)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            </Box>
                        </>
                    }

                </>
            }
            {/*<pre>*/}
            {/*            {JSON.stringify(map_sec_history(props.match.params.id ,data?.transactions), null, 4)}*/}
            {/*        </pre>*/}
            {/*<pre>*/}
            {/*            {JSON.stringify(sec, null, 4)}*/}
            {/*        </pre>*/}

        </Container>
    )
}